import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import ActivityACHPage, { getDefaultData } from "components/pages/ActivityACHPage";
import Classes from "model";

/**
 * @function CaptureACHApprovalsActivityApproved
 * @param {Void} - No arguments are passed.
 * @returns {React.Component}
 * @description Component in the MABI23 "Approvals" capture group.
 */
export default function CaptureACHApprovalsActivityApproved() {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    const achBatches = getDefaultData()
    .pendingSameDayACHBatchesWidgetData.achBatches
    .map(item => {
        item.status = "pending processing";
        return item;
    });

    const data = BCMSStateManagerCRUD.init(getDefaultData())
    .update([ "pendingSameDayACHBatchesWidgetData", "achBatches" ], achBatches)
    .update([ "showSuccessBanner"], { show: true })
    .update([ "approvedACHBatch"], { batch: achBatches[0] })
    .submit();

    return <ActivityACHPage data={ data } />
}